import { useState, useEffect, useRef } from 'react';

const Search = ({ items }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const debounceTimerRef = useRef(null);

  const handleSearch = () => {
    if (searchTerm && searchTerm.length >= 2) {
      const filtered = items.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredResults(filtered);
      setShowResults(true);
    } else {
      setFilteredResults([]);
      setShowResults(false);
    }
  };

  // Clean debounce when component unmounts
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      // Clear any existing timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      
      // If search term is valid (2+ characters), navigate to search results page
      if (searchTerm && searchTerm.length >= 2) {
        window.location.href = `/search-results?q=${encodeURIComponent(searchTerm)}`;
      } else {
        // Run search immediately on Enter for dropdown
        handleSearch();
      }
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    
    // Clear any existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    
    // Set a new timer (300ms delay)
    debounceTimerRef.current = setTimeout(() => {
      if (value && value.length >= 2) {
        handleSearch();
      } else {
        setFilteredResults([]);
        setShowResults(false);
      }
    }, 300);
  };

  const handleResultClick = (result) => {
    setSearchTerm(result.title);
    setShowResults(false);
    window.location.href="/a/"+result.slug;
  };

  return (
    <div className="searchContainer">
      <input
        type="text"
        className="form-control h7"
        placeholder="Search titles"
        value={searchTerm}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      
      {showResults && filteredResults.length > 0 && (
        <ul className="dropdownSearh">
          {filteredResults.map((item) => (
            <li 
              key={item.id} 
              onClick={() => handleResultClick(item)} 
              className="dropdownItem"
            >
              {item.title}
            </li>
          ))}
        </ul>
      )}

      <style jsx global>{`
        .searchContainer {
          position: relative;
        }

        .dropdownSearh {
          position: absolute;
          top: 100%;
          left: 0;
          border: 1px solid #ddd;
          background-color: white;
          max-height: 200px;
          overflow-y: auto;
          z-index: 1000; 
          list-style-type: none;
          padding: 0;
          margin: 0;
        }

        .dropdownItem {
          padding: 10px;
          cursor: pointer;
          border-bottom: 1px solid #ddd;
        }

        .dropdownItem:hover {
          background-color: #f0f0f0;
        }
      `}</style>
    </div>
  );
};

export default Search;